import { TeamType } from "msd-capacity-planning-model";

const types = [TeamType.AWS, TeamType.AZURE, TeamType.GCP, TeamType.MULTICLOUD];

export function useTeamTypes(): TeamType[] {
  return types;
}
